'use client'

import { usePasses } from '../hooks/usePasses'
import { applyObjectiveProgress, PASS_PAGE_VARIANT } from '../lib/pass-ui'

import { useUserProgress } from '@/shared/contexts/UserProgress'
import { Card, CardBody, CardHeader, CardTitle } from '@/shared/ui/Card'
import { NotFoundAlert } from '@/shared/ui/NotFoundAlert'
import { Page } from '@/shared/ui/Page'

import { PassCard } from './PassCard'

export function PassesListPage() {
  const { data: passes = [], isLoading } = usePasses()
  const { passObjectiveProgresses } = useUserProgress()
  const enrichedPasses = applyObjectiveProgress(passes, passObjectiveProgresses)

  return (
    <Page variant={PASS_PAGE_VARIANT}>
      <div className="flex w-full min-w-0 max-w-full flex-col items-center gap-5 px-0">
        {isLoading ? (
          <Card variant={PASS_PAGE_VARIANT} className="w-full max-w-2xl">
            <CardHeader>
              <CardTitle>Passe de Objetivos</CardTitle>
            </CardHeader>
            <CardBody>
              <p className="text-center text-sm font-medium text-[#7F7FAD]">
                Carregando seus passes…
              </p>
            </CardBody>
          </Card>
        ) : passes.length === 0 ? (
          <Card variant={PASS_PAGE_VARIANT} className="w-full max-w-2xl">
            <CardHeader>
              <CardTitle>Passe de Objetivos</CardTitle>
            </CardHeader>
            <CardBody>
              <NotFoundAlert
                title="Nenhum passe ativo"
                text="Quando houver um passe da plataforma ou de uma campanha em que você participa, ele aparecerá aqui."
              />
            </CardBody>
          </Card>
        ) : (
          enrichedPasses.map(pass => <PassCard key={pass.id} pass={pass} />)
        )}
      </div>
    </Page>
  )
}
